module.exports = __webpack_public_path__ + "img/125.31463cc0.webp";